import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=5e24a157"
import script from "./AddDocument.vue?vue&type=script&lang=ts"
export * from "./AddDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports